import './App.scss';
import React, {useState, useEffect} from 'react';
import {Routes, Route, BrowserRouter} from 'react-router-dom';
import Faq from './components/Faq';

function AppContent() {
    const [scrolling, setScrolling] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setScrolling(true);
            } else {
                setScrolling(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const handleLinkClickToTerms = () => {
        window.open('https://brainwave.geniustech.ai/user-agreement/terms_of_use.pdf', '_blank');
    };

    const handleLinkClickToEmail = () => {
        window.open('mailto:brainwave.support@geniustech.ai', '_blank');
    };

    const handleLinkClickToPrivate = () => {
        window.open('https://brainwave.geniustech.ai/user-agreement/privacy_notice.pdf', '_blank');
    };

    const handleLocateToAppStore = () => {
        window.open('https://brainwave.geniustech.ai/us/app/fitmeal-health-fitness-recipe/id6504800448', '_blank');
    };

    return (
        <div className="App">
            <header className={scrolling ? "header header-scrolled" : "header"}>
                <div className='container'>
                    <div className='navL'>
                        <img src="./nav_logo.png" alt="" style={{width: '190px'}}/>
                    </div>
                    <div className='navR'>
                        <div
                            onClick={() => window.open('https://apps.apple.com/your-app-url', '_blank')}
                            className='store'>
                            App Store
                        </div>
                        <div
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            style={{backgroundColor: isHovered ? '#A781F8' : '#A781F8'}}
                            className='download'>
                            Download
                            {isHovered && (
                                <div className='qrCode'>
                                    <div className='triangle'>
                                        <img src="./triangle.png" alt=""/>
                                    </div>
                                    <div className='qrcode'>
                                        <img src="./qrcode.png" alt=""/>
                                    </div>
                                    <div className='text'>
                                        <div>
                                            <img src="./scan.png" alt=""/>
                                        </div>
                                        <div>Scan to download</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>
            <div className='section'>
                <div className='left'>
                    <img src="./left.png" alt=""/>
                </div>
                <div className='right'>
                    <div className='icon'>
                        <img src="./icon.png" alt=""/>
                    </div>
                    <div className='name'>BrainWave</div>
                    <div className='desc'>
                        Experience personalized sleep enhancement with real-time monitoring and adaptive brainwave
                        music—designed to help you fall asleep faster, sleep deeper, and wake up refreshed. Brainwave
                        intelligently detects your sleep state through heart rate, snoring patterns, and other signals,
                        dynamically adjusting audio stimulation to guide your brain into optimal rest phases. Achieve
                        better sleep naturally with our science-backed approach. Whether you're a light sleeper or
                        seeking more restorative nights, Brainwave empowers your body and mind to recharge fully.
                        <p>&nbsp;</p>
                        <p>
                            For inquiries or support, contact email:&nbsp;
                            <a href="mailto:brainwave.support@geniustech.ai">brainwave.support@geniustech.ai</a>
                        </p>
                    </div>
                </div>
            </div>
            <footer className='footer'>
                <div className='container'>
                    <div className='footerL'>
                        <div className='title'>BrainWave</div>
                        <div className='copyright'>2025 © Genius Al Labs Pte. Ltd. All Rights Reserved.</div>
                    </div>
                    <div className='footerR'>
                        <div className='item'>
                            <div className='link'
                                 onClick={handleLinkClickToPrivate}
                            >Privacy Policy
                            </div>
                        </div>
                        <div className='item'>
                            <div className='link'
                                 onClick={handleLinkClickToTerms}
                            >Terms of Use
                            </div>
                        </div>
                        <div className='item'>
                            <div className='link'
                                 onClick={handleLinkClickToEmail}
                            >Email:brainwave.support@geniustech.ai
                            </div>

                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<AppContent/>}/>
                {/*<Route path="/faq" element={<Faq/>}/>*/}
            </Routes>
        </BrowserRouter>
    );
}

export default App;
